import { defineMessages } from 'react-intl';

export const messages: {
	rovoAgentIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	rovoAgentIconLabel: {
		id: 'studio-trigger-solution-build-plan-card.title-icon-picker.rovo-agent-icon-label',
		defaultMessage: 'Rovo Agent',
		description: 'Rovo Agent icon label (displayed in the card)',
	},
});
